import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./app/store";
import { BrowserRouter } from "react-router-dom";
import { StyleSheetManager } from "styled-components";
import isPropValid from "@emotion/is-prop-valid";
import watchForStaleBuild from "./utils/staleBuild";
import watchForSessionChange from "./utils/sessionSync";

/**
 * Keep styling props out of the DOM.
 *
 * Several components pass presentational props (backgroundColor, textColor,
 * marginBottom, sortActive) straight into styled elements. styled-components
 * forwards anything it does not recognise, so React was writing them onto the
 * HTML and logging a warning for each one. This filters custom props on plain
 * DOM elements while leaving props to React components alone.
 */
const shouldForwardProp = (prop, target) =>
  typeof target === "string" ? isPropValid(prop) : true;

/*
 * Before anything renders: a tab older than the deployment asks for chunk
 * filenames that no longer exist, and until now that just stopped the screen
 * working with an error only in the console.
 */
watchForStaleBuild();

/*
 * Tabs share one localStorage, so signing in as somebody else in a second tab
 * replaces this tab's session underneath it. Without this the tab kept polling
 * with the new account's token against the old account's screen, and crashed.
 */
watchForSessionChange();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StyleSheetManager>
  </Provider>
);
